import React from "react";
import { Chip } from "@mui/material";

interface FeaturePillProps {
  icon?: React.ReactElement;
  label: string;
}

const FeaturePill: React.FC<FeaturePillProps> = ({ icon, label }) => (
  <Chip
    icon={icon}
    label={label}
    variant="outlined"
    sx={{
      height: 34,
      fontWeight: 600,
      fontSize: "0.875rem",
      borderColor: "divider",
      bgcolor: "background.paper",
      "& .MuiChip-label": { px: "12px" },
      "& .MuiChip-icon": { fontSize: "1.125rem", color: "primary.main" }
    }}
  />
);

export default FeaturePill;
